<template>
  <el-card>
    <div v-wechat-title="title" />

    <template #header>
      <content-header />
    </template>

    <el-row type="flex" justify="left">
      <el-col :span="20">
        <!-- <strong>订单号: {{ form.order_id }}</strong> -->
        <div style="margin: 8px;" />
        <el-tag type="info">{{ form.order_type_text }}</el-tag>
        <el-divider direction="vertical" />
        <el-tag type="warning">{{ form.audit_status_text }}</el-tag>
        <el-divider direction="vertical" />
        <el-tag>{{ form.status_text }}</el-tag>
        <el-divider direction="vertical" />
        <el-tag type="danger" v-if="form.pick_up_order">自提</el-tag>
      </el-col>
      <el-col v-if="form.status == 0 && form.audit_status == 1 && hasPermsDeliveryStatus" :span="4">
        <span class="text item">
          发货状态操作:
           <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link"> 发货类型<i class="el-icon-arrow-down el-icon--right" /> </span>
            <el-dropdown-menu slot="dropdown">
               <el-dropdown-item command="a">
                <el-popconfirm title="确认中通快递管家发货？" @confirm="sendExPress(1)">
                  <el-button type="text" slot="reference">中通快递管家发货</el-button>
                </el-popconfirm>
              </el-dropdown-item>
              <el-dropdown-item command="b">
                  <el-button type="text">发货</el-button>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </span>
      </el-col>
    </el-row>

    <el-divider content-position="left">订单信息</el-divider>

    <el-row type="flex" justify="left">
      <lz-form
        ref="form"
        :get-data="getData"
        :submit="onSubmit"
        :form.sync="form"
        :errors.sync="errors"
        :edit-mode="editMode"
        disable-stay
        :info-mode="true"
      >
        <el-form-item label="基础信息">
          <el-row :gutter="12">
            <el-card>
              <el-col :span="11">
                <div class="text item">订单号:{{ form.order_id }}</div>
                <div class="text item">下单时间:{{ form.created_at }}</div>
                <div class="text item">支付时间:{{ form.pay_time }}</div>
              </el-col>
              <el-col :span="11" v-if="!isLogistics">
                <div class="text item">总金额:{{ form.total_amount }}</div>
                <div class="text item">运费:{{ form.freight }}</div>
                <div class="text item">优惠金额:{{ form.pmt_amount }}</div>
                <div class="text item">实付金额:{{ form.final_amount }}</div>
              </el-col>
            </el-card>
          </el-row>
        </el-form-item>

        <!-- <el-form-item label="代理信息">
          <el-row :gutter="12">
            <el-card>
              <el-col :span="11">
                <div class="text item">姓名:{{ form.user.real_name }}</div>
                <div v-if="!isLogistics" class="text item">手机:{{ form.user.mobile }}</div>
              </el-col>
              <el-col :span="11" v-if="!isLogistics">
                <div class="text item">级别:{{ form.user.level_name }}</div>
                <div class="text item">所属团队:{{ !form.user.parent_user ? '总部' : form.user.parent_user.real_name }}</div>
              </el-col>
            </el-card>
          </el-row>
        </el-form-item> -->

        <el-form-item label="商品详情">
          <el-card>
            <el-table :data="form.items" style="width: 100%">
              <el-table-column prop="name" label="商品名称" />
              <el-table-column prop="price" v-if="!isLogistics" label="价格" />
              <el-table-column prop="nums" label="购买数量" />
              <el-table-column prop="amount" v-if="!isLogistics" label="小计" />
            </el-table>
          </el-card>
        </el-form-item>

        <el-form-item label="仓库信息">
          <el-row :gutter="12">
            <el-card>
              <el-col :span="11">
                <div class="text item">仓库名称:{{ form.warehouse.name }}</div>
              </el-col>
              <el-col :span="11">
                <div class="text item">联系方式:{{ form.warehouse.username }}/{{ form.warehouse.mobile }}</div>
              </el-col>
              <el-col>
                <div class="text item">仓库地址:{{ form.warehouse.city + form.warehouse.address }}</div>
                <div />
              </el-col>
            </el-card>
          </el-row>
        </el-form-item>

        <el-form-item label="物流信息">
          <el-row :gutter="12">
            <el-card>
              <el-col :span="11">
                <div class="text item">姓名:{{ form.ship_name }}</div>
              </el-col>
              <el-col :span="11">
                <div class="text item">电话:{{ form.ship_mobile }}</div>
                <!-- <div class="text item">快递公司:{{ form.express_company_name }}</div>
                <div class="text item">快递单号:{{ form.express_no }}</div> -->
              </el-col>
              <el-col>
                <div class="text item">
                  地址: {{ form.ship_area + form.ship_addr }}
                  <el-button
                    type="primary"
                    plain
                    icon="el-icon-edit"
                    size="mini"
                    @click="showUpdateAddressDialog"
                    v-if="form.status == 0 && hasPermsOrdersUpdate"
                  />
                </div>
                <div />
              </el-col>

              <el-col v-if="hasPermsExpress">
                <el-card v-for="(express, index) in form.express_no_array" :key="index" class="box-card" shadow="hover">
                  <div class="clearfix">
                    <span>包裹{{ index + 1 }}</span>
                    <el-button
                      v-if="hasPermsDeliveryExpress && (form.express_no_array && form.express_no_array.length > 0) && index == 0"
                      style="float: right; padding: 3px 0"
                      type="text"
                      @click="modifyExpress"
                    >
                      修改
                    </el-button>
                    <span style=" padding: 3px 0">
                      <br>
                      快递公司:{{ form.express_company_name_array[index] }}
                      <br>
                      快递单号:{{ express }}
                    </span>
                  </div>
                </el-card>
              </el-col>
            </el-card>
          </el-row>
        </el-form-item>

        <el-form-item label="订单日志">
          <el-card>
            <el-timeline :reverse="false">
              <el-timeline-item
                color="#0bbd87"
                v-for="(log, index) in form.logs"
                :key="index"
                :timestamp="log.created_at"
              >
                {{ log.log_text }} {{ log.op_name ? '(' + log.op_name + ')' : '' }}
              </el-timeline-item>
            </el-timeline>
          </el-card>
        </el-form-item>

        <el-form-item label="备注信息">
          <el-row :gutter="12">
            <el-card>
              <el-col>
                <div class="text item">用户留言:{{ form.memo }}</div>
                <div class="text item">订单备注:{{ form.mark_text }}</div>
              </el-col>
            </el-card>
          </el-row>
        </el-form-item>
      </lz-form>
    </el-row>

    <el-dialog title="修改地址" :visible.sync="updateAddressDialog" width="400px" append-to-body>
      <lz-form
        style="width: auto;"
        ref="addressForm"
        :submit="onUpdateAddress"
        :errors.sync="errors"
        :model="addressForm"
        label-position="top"
        in-dialog
        disable-redirect
        disable-stay
      >
        <el-form-item label="省市地区" required prop="ship_aera_code">
          <city-cascader ref="cityCascader" v-model="addressForm.ship_aera_code" />
        </el-form-item>
        <el-form-item label="地址信息" required prop="ship_addr">
          <el-input v-model="addressForm.ship_addr" />
        </el-form-item>
      </lz-form>
    </el-dialog>

    <el-dialog title="修改备注" :visible.sync="updateMarkDialog" width="400px" append-to-body>
      <lz-form
        style="width: auto;"
        ref="upMark"
        :submit="onUpdateMarkText"
        :errors.sync="errors"
        :model="upMark"
        label-position="top"
        in-dialog
        disable-redirect
        disable-stay
      >
        <el-form-item label="订单备注" required prop="mark_text">
          <el-input v-model="upMark.mark_text" />
        </el-form-item>
      </lz-form>
    </el-dialog>

    <el-dialog
      title="更新快递信息"
      :visible.sync="updateExpressDialog"
      width="750px"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-alert title="可以添加多个包裹，最多添加为5个包裹。" type="warning" />
      <lz-form
        style="width: auto;"
        ref="upMark"
        :inline="true"
        :submit="onUpdateExpress"
        :errors.sync="errors"
        label-position="left"
        label-width="100px"
        in-dialog
        disable-redirect
        disable-stay
      >
        <el-card
          v-for="(express, index) in expressForm"
          :key="index"
          class="box-card"
          shadow="hover"
          :body-style="{ padding: '20px', 'margin-bottom': '-20px' }"
        >
          <div slot="header" class="clearfix">
            <span>包裹{{ index + 1 }}</span>
            <el-button v-if="index == 0" style="float: right; padding: 3px 0" type="text" @click="onAddExpress">添加
            </el-button>
            <el-button
              v-else
              style="float: right; padding: 3px 0; color:#f56c6c;"
              type="text"
              @click="onDeleteExpress(express, index)"
            >
              删除
            </el-button>
          </div>
          <el-form-item label="快递公司:" required :prop="'express.' + index + '.express_company_code'">
            <el-select
              ref="expressCompany"
              @change="selectModel($event, express)"
              v-model="express.express_company_code"
              placeholder="请选择"
            >
              <el-option v-for="item in configs" :key="item.id" :label="item.name" :value="item.slug" />
            </el-select>
          </el-form-item>
          <el-form-item label="快递单号:" required :prop="'express.' + index + '.express_no'">
            <el-input v-model="express.express_no" />
          </el-form-item>
        </el-card>
      </lz-form>
    </el-dialog>

    <el-dialog
      title="更新快递信息"
      :visible.sync="modifyExpressDialog"
      width="750px"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-alert title="可以添加多个包裹，最多添加为5个包裹。" type="warning" />
      <lz-form
        style="width: auto;"
        ref="upMark"
        :inline="true"
        :submit="onModifyExPress"
        :errors.sync="errors"
        label-position="left"
        label-width="100px"
        in-dialog
        disable-redirect
        disable-stay
      >
        <el-card
          v-for="(express, index) in modifyExpressForm"
          :key="index"
          class="box-card"
          shadow="hover"
          :body-style="{ padding: '20px', 'margin-bottom': '-20px' }"
        >
          <div slot="header" class="clearfix">
            <span>包裹{{ index + 1 }}</span>
            <el-button v-if="index == 0" style="float: right; padding: 3px 0" type="text" @click="onAddModifyExpress">添加
            </el-button>
            <el-button
              v-else
              style="float: right; padding: 3px 0; color:#f56c6c;"
              type="text"
              @click="onDeleteModifyExpress(express, index)"
            >
              删除
            </el-button>
          </div>
          <el-form-item label="快递公司:" required :prop="'express.' + index + '.express_company_code'">
            <el-select
              ref="expressCompany"
              @change="selectModel($event, express)"
              v-model="express.express_company_code"
              placeholder="请选择"
            >
              <el-option v-for="item in configs" :key="item.id" :label="item.name" :value="item.slug" />
            </el-select>
          </el-form-item>
          <el-form-item label="快递单号:" required :prop="'express.' + index + '.express_no'">
            <el-input v-model="express.express_no" />
          </el-form-item>
        </el-card>
      </lz-form>
    </el-dialog>
  </el-card>
</template>

<script>
import { createOrder, editOrder, modifyDeliveryStatus, modifyDeliveryStatusExpress, storeOrder, updateOrder } from '@/api/order-offline'
import { can, getFirstError } from '@/libs/utils'
import CityCascader from '@c/CityCascader'
import LzForm from '@c/LzForm'
import FormHelper from '@c/LzForm/FormHelper'

export default {
  name: 'Form',
  components: {
    LzForm,
    CityCascader,
  },
  mixins: [FormHelper],
  data() {
    return {
      title: '编辑订单',
      form: {
        id: 0,
        order_id: '',
        order_type: 0,
        order_type_text: '',
        user_id: 0,
        title: '',
        item_num: 0,
        freight: 0.0,
        pmt_amount: 0.0,
        total_amount: 0.0,
        final_amount: 0.0,
        league_order: 0.0,
        memo: '',
        status: 0,
        status_text: '',
        confirm_time: '',
        belong_one: '',
        belong_three: '',
        belong_two: '',
        belong_path: '',
        audit_date: '',
        audit_status: 0,
        audit_status_text: '',
        audit_time: '',
        integral_rate: '',
        pay_integral: '',
        pay_time: '',
        pay_status: 0,
        pick_up_order: '',
        ship_name: '',
        ship_addr: '',
        ship_aera_code: [],
        ship_area: '',
        ship_mobile: '',
        ship_time: '',
        express_no: '',
        express_no_array: [],
        express_company_code: '',
        express_company_code_array: [],
        express_company_name: '',
        express_company_name_array: [],
        delivery_id: '',
        belong_delivery_user_name: '',
        mark_text: '',
        user: {},
        warehouse: {},
        items: [],
        logs: [],
        created_at: '',
        updated_at: '',
      },
      addressForm: {
        ship_addr: '',
        ship_aera_code: [],
        ship_area: '',
      },

      upMark: {
        mark_text: '',
      },
      expressForm: [
        {
          express_no: '',
          express_company_code: '',
          express_company_name: '',
        },
      ],
      modifyExpressForm: [
        {
          express_no: '',
          express_company_code: '',
          express_company_name: '',
        },
      ],

      configs: [],

      updateAddressDialog: false,
      updateMarkDialog: false,
      updateExpressDialog: false,

      modifyExpressDialog: false,
      // cityCascader: ['110000', '110100', '110101'],
      errors: {},

      hasPermsExpress: false,
      hasPermsDeliveryStatus: false,
      hasPermsDeliveryExpress: false,
      hasPermsOrdersUpdate: false,
      isLogistics: false,
    }
  },
  computed: {},
  created() {
    this.hasPermsDeliveryStatus = can('order.offline.delivery-status')
    this.hasPermsDeliveryExpress = can('order.offline.delivery-express')
    this.hasPermsOrdersUpdate = can('order.offline.update')
    this.hasPermsExpress = can('order.offline.express')
  },
  methods: {
    async getData() {
      if (this.editMode) {
        const {
          data: { data, isLogistics, configs },
        } = await editOrder(this.resourceId)
        this.fillForm(data)
        if (!this.form.warehouse) {
          this.form.warehouse = {}
        }
        this.isLogistics = isLogistics
        this.configs = configs
        this.title = '订单号:' + this.form.order_id
        this.$route.meta.title = this.title
        this.$store.dispatch('tagsView/updateVisitedView', this.$route)
      } else {
        const {
          data: { data },
        } = await createOrder()
        // console.log(data)
      }
    },
    async onSubmit() {
      if (this.editMode) {
        await updateOrder(this.resourceId, this.form)
      } else {
        await storeOrder(this.form)
      }
    },
    async getCityData() {
      console.log(this.cityCascader)
    },
    async showUpdateAddressDialog() {
      this.addressForm.ship_aera_code = this.form.ship_aera_code
      this.addressForm.ship_area = this.form.ship_area
      this.addressForm.ship_addr = this.form.ship_addr
      this.updateAddressDialog = true
    },
    async showUpdateExpressDialog() {
      this.updateExpressDialog = true
    },
    async onUpdateAddress() {
      if (this.addressForm.ship_aera_code.length <= 0) {
        return false
      }
      this.addressForm.ship_area = this.$refs['cityCascader'].$refs['CityCascader'].inputValue
      this.addressForm.ship_area = this.addressForm.ship_area.replace(/\s*/g, '')
      const { data } = await updateOrder(this.resourceId, this.addressForm)

      this.updateAddressDialog = false
      this.getData()
    },
    async selectModel(id, express) {
      console.log(id, express)
      let obj = {}
      obj = this.configs.find(item => {
        // configs就是上面的数据源
        return item.slug === id // 筛选出匹配数据
      })
      express.express_company_name = obj.name
      // console.log('modelName' + this.expressForm.express_company_name);
    },
    handleCommand(command) {
      if (command === 'b') {
        this.sendExPress(2);
      }
    },
    async sendExPress(action) {
      if (action === 2) {
        this.showUpdateExpressDialog()
      } else {
        // 中通快递管家发货
        try {
          await modifyDeliveryStatus(this.form.order_id, {action: 1})
          this.getData()
          this.$message.success('提交成功')
        } catch (e) {
          const res = e.response
          const err = getFirstError(res)
          console.log(res, err)
          err && this.$message.error(err)
        }
      }
    },
    async onUpdateExpress() {
      const {data} = await modifyDeliveryStatus(this.form.order_id, {express: this.expressForm, action: 2});
      this.updateExpressDialog = false
      this.getData()
    },
    async showUpdateMarkDialog() {
      this.upMark.mark_text = this.form.mark_text

      this.updateMarkDialog = true
    },
    async onUpdateMarkText() {
      if (this.upMark.mark_text == '') {
        this.updateMarkDialog = false
        return
      }
      const { data } = await updateOrder(this.resourceId, this.upMark)

      this.updateMarkDialog = false
      this.getData()
    },

    async onAddExpress() {
      if (this.expressForm.length >= 5) {
        return
      }
      this.expressForm.push({
        express_no: '',
        express_company_code: '',
        express_company_name: '',
      })
    },

    async onDeleteExpress(item) {
      const index = this.expressForm.indexOf(item)
      if (index !== -1) {
        this.expressForm.splice(index, 1)
      }
    },

    modifyExpress() {
      this.modifyExpressForm = []
      if (this.form.express_no_array.length > 0) {
        for (let i = 0; i < this.form.express_no_array.length; i++) {
          this.modifyExpressForm.push({
            express_no: this.form.express_no_array[i],
            express_company_code: this.form.express_company_code_array[i],
            express_company_name: this.form.express_company_name_array[i],
          })
        }
      }
      this.modifyExpressDialog = true
    },
    async onModifyExPress() {
      try {
        const { data } = await modifyDeliveryStatusExpress(this.form.order_id, { express: this.modifyExpressForm,action:2 })
        this.modifyExpressDialog = false
        this.getData()
        // this.$message.success('修改成功')
      } catch (e) {
        const res = e.response
        const err = getFirstError(res)
        console.log(res, err)
        err && this.$message.error(err)
      }
    },

    async onAddModifyExpress() {
      if (this.modifyExpressForm.length >= 5) {
        return
      }
      this.modifyExpressForm.push({
        express_no: '',
        express_company_code: '',
        express_company_name: '',
      })
    },

    async onDeleteModifyExpress(item) {
      const index = this.modifyExpressForm.indexOf(item)
      if (index !== -1) {
        this.modifyExpressForm.splice(index, 1)
      }
    },
  },
  watch: {
    updateAddressDialog(newVal) {
      console.log('updateAddressDialog', newVal);

      if (!newVal) {
        this.addressForm = {
          ship_aera_code: this.form.ship_aera_code,
          ship_aera: this.form.ship_aera,
          ship_addr: this.form.ship_addr,
        }

        console.log('this.addressForm', this.addressForm);
      }
    },
    updateMarkDialog(newVal) {
      if (!newVal) {
        this.upMark.mark_text = this.form.mark_text
      }
    },
    updateExpressDialog(newVal) {
      if (!newVal) {
        // this.upMark.mark_text = this.form.mark_text;
      }
    },
  },
}
</script>

<style scoped lang="scss">
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>
